// Paginated Blocks JavaScript
class PaginatedBlocks {
  constructor(section) {
    this.section = section;
    this.sectionId = section.dataset.sectionId;
    this.blocksPerPage = parseInt(section.dataset.blocksPerPage) || 6;
    this.totalBlocks = parseInt(section.dataset.totalBlocks) || 0;
    this.currentPage = 1;
    this.totalPages = Math.ceil(this.totalBlocks / this.blocksPerPage);
    this.ajaxEnabled = section.dataset.ajaxEnabled === 'true';
    
    this.init();
  }
  
  init() {
    this.cacheElements();
    this.bindEvents();
    this.updatePagination();
  }
  
  cacheElements() {
    this.blocksGrid = document.getElementById(`BlocksGrid-${this.sectionId}`);
    this.paginationWrapper = document.getElementById(`Pagination-${this.sectionId}`);
    this.prevBtn = this.section.querySelector('[data-pagination-prev]');
    this.nextBtn = this.section.querySelector('[data-pagination-next]');
    this.pageNumbers = this.section.querySelectorAll('.pagination-number');
    this.pageInfo = this.section.querySelector('[data-pagination-info]');
    this.currentPageSpan = this.section.querySelector('[data-current-page]');
    this.totalPagesSpan = this.section.querySelector('[data-total-pages]');
    
    this.allBlocks = this.section.querySelectorAll('.block-item');
  }
  
  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.goToPage(this.currentPage - 1));
    }
    
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.goToPage(this.currentPage + 1));
    }
    
    this.pageNumbers.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const page = parseInt(e.currentTarget.dataset.page);
        this.goToPage(page);
      });
    });
    
    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (e.target.closest(`.paginated-blocks-section[data-section-id="${this.sectionId}"]`)) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.goToPage(this.currentPage - 1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.goToPage(this.currentPage + 1);
        }
      }
    });
  }
  
  goToPage(page) {
    if (page < 1 || page > this.totalPages || page === this.currentPage) return;
    
    this.currentPage = page;
    
    if (this.ajaxEnabled) {
      this.animatePageTransition(() => this.showPage(page));
    } else {
      this.showPage(page);
    }
    
    this.updatePagination();
    this.updateURL(page);
    this.announcePageChange(page);
  }
  
  showPage(page) {
    const startIndex = (page - 1) * this.blocksPerPage;
    const endIndex = startIndex + this.blocksPerPage;
    
    this.allBlocks.forEach((block, index) => {
      if (index >= startIndex && index < endIndex) {
        block.style.display = 'flex';
        block.removeAttribute('aria-hidden');
      } else {
        block.style.display = 'none';
        block.setAttribute('aria-hidden', 'true');
      }
    });
  }
  
  animatePageTransition(callback) {
    this.blocksGrid.style.opacity = '0.5';
    this.blocksGrid.style.transition = 'opacity 0.3s ease';
    
    setTimeout(() => {
      callback();
      setTimeout(() => {
        this.blocksGrid.style.opacity = '1';
        // Scroll to top of blocks grid
        this.blocksGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    }, 300);
  }
  
  updatePagination() {
    // Update button states
    if (this.prevBtn) {
      this.prevBtn.disabled = this.currentPage === 1;
      this.prevBtn.setAttribute('aria-disabled', this.currentPage === 1 ? 'true' : 'false');
    }
    
    if (this.nextBtn) {
      this.nextBtn.disabled = this.currentPage === this.totalPages;
      this.nextBtn.setAttribute('aria-disabled', this.currentPage === this.totalPages ? 'true' : 'false');
    }
    
    // Update page number buttons
    this.pageNumbers.forEach(btn => {
      const pageNum = parseInt(btn.dataset.page);
      btn.classList.toggle('pagination__item--current', pageNum === this.currentPage);
      btn.setAttribute('aria-current', pageNum === this.currentPage ? 'page' : 'false');
    });
    
    // Update page info
    if (this.currentPageSpan) {
      this.currentPageSpan.textContent = this.currentPage;
    }
    
    if (this.totalPagesSpan) {
      this.totalPagesSpan.textContent = this.totalPages;
    }
  }
  
  updateURL(page) {
    if (history.pushState && page > 1) {
      const url = new URL(window.location);
      url.searchParams.set(`page-${this.sectionId}`, page);
      history.pushState({}, '', url);
    } else if (page === 1 && history.pushState) {
      const url = new URL(window.location);
      url.searchParams.delete(`page-${this.sectionId}`);
      history.pushState({}, '', url);
    }
  }
  
  announcePageChange(page) {
    // Announce page change for screen readers
    const announcement = document.createElement('div');
    announcement.setAttribute('aria-live', 'polite');
    announcement.setAttribute('aria-atomic', 'true');
    announcement.classList.add('visually-hidden');
    announcement.textContent = `Page ${page} of ${this.totalPages}`;
    
    this.section.appendChild(announcement);
    setTimeout(() => announcement.remove(), 1000);
  }
}

// Initialize all paginated blocks sections on the page
document.addEventListener('DOMContentLoaded', function() {
  const paginatedSections = document.querySelectorAll('.paginated-blocks-section');
  
  paginatedSections.forEach(section => {
    new PaginatedBlocks(section);
  });
  
  // Handle browser back/forward buttons
  window.addEventListener('popstate', function() {
    const urlParams = new URLSearchParams(window.location.search);
    paginatedSections.forEach(section => {
      const sectionId = section.dataset.sectionId;
      const pageParam = urlParams.get(`page-${sectionId}`);
      if (pageParam) {
        const paginatedBlocks = new PaginatedBlocks(section);
        paginatedBlocks.goToPage(parseInt(pageParam));
      }
    });
  });
});